import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent,
  IgxInputGroupModule, IgxPrefixDirective, IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IgxButtonDirective, IgxButtonModule, IgxRippleDirective, IgxRippleModule } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent, IgxIconModule } from '@infragistics/igniteui-angular/icon';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-busqueda-libro',
  templateUrl: './busqueda-libro.component.html',
  styleUrls: ['./busqueda-libro.component.scss'],
  imports: [
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxIconComponent,
    IgxButtonModule,
    IgxButtonDirective,
    TranslateModule,
    IgxRippleModule,
    IgxRippleDirective,
    IgxInputGroupComponent,
    IgxPrefixDirective,
    IgxSuffixDirective
  ]
})
export class BusquedaLibroComponent implements OnInit {
  @ViewChild('libroExcel', {read: IgxInputDirective, static: true})
  public libroExcel: IgxInputDirective;

  @ViewChild('fileInput1', {read: IgxInputDirective, static: true})
  public fileInput1: IgxInputDirective;
  // config btn vista previa o modificar
  @Input()
  public titleVistaPrevia = 'MENSAJES.GRALS.VISTA_PREVIA';
  @Input()
  public iconVistaPrevia = 'edit';
  @Input()
  public textoVistaPrevia = 'MENSAJES.GRALS.VISTA_PREVIA';
  @Input()
  public mostrarBtnVistaPrevia = true;
  @Input()
  public desactivarBtnVistaPrevia = false;
  // config btn subir archivo
  @Input()
  public titleSubirArchivo: string;
  @Input()
  public iconSubirArchivo = 'file_upload';
  @Input()
  public formatosValidarSubirArchivo = '.xlsx, .xls';
  @Input()
  public mostrarBtnSubirArchivo = true;
  @Input()
  public desactivarBtnSubirArchivo = false;
  // config input
  @Input()
  public etiquetaInput: string;
  @Input()
  public placeholderInput = 'MENSAJES.GRALS.NINGUN_ARCHIVO_ELEGIDO';
  @Input()
  public readonlyInput = true;
  @Input()
  public valorInput = '';
  // config limpiar valor
  @Input()
  public mostrarBtnLimpiar = false;
  // config btn descargar
  @Input()
  public titleBajarArchivo: string;
  @Input()
  public iconBajarArchivo = 'file_download';
  @Input()
  public mostrarBtnBajarArchivo = true;
  @Input()
  public desactivarBtnBajarArchivo = false;
  // config btn buscar libro
  @Input()
  public titleBuscarDocumento = 'MENSAJES.GRALS.BUSCAR_DOCUMENTO';
  @Input()
  public iconBuscarLibro = 'search';
  @Input()
  public mostrarBtnBuscarLibro = true;
  @Input()
  public desactivarBtnBuscarLibro = false;

  // eventos de regreso de cada accion del control
  @Output()
  public evtVistaPrevia: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public evtSubirArchivo: EventEmitter<Event> = new EventEmitter<Event>();
  @Output()
  public evtLimpiarInput: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public evtBajarArchivo: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public evtObtenerListadoLibro: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

}
